module.exports = __webpack_public_path__ + "media/truth_initiative/truth-logo-orange_316x86-fdb309de.svg";